module.exports = __webpack_public_path__ + "img/ic-txt-list-del.a9e7224d.svg";